import {
  DEPARTMENT_LIST_REQUEST,
  DEPARTMENT_LIST_SUCCESS,
  DEPARTMENT_LIST_FAIL,
  CATEGORY_LIST_REQUEST,
  CATEGORY_LIST_SUCCESS,
  CATEGORY_LIST_FAIL,
  CATEGORY_SINGLE_REQUEST,
  CATEGORY_SINGLE_SUCCESS,
  CATEGORY_SINGLE_FAIL,
  CATEGORY_SEARCH_REQUEST,
  CATEGORY_SEARCH_SUCCESS,
  CATEGORY_SEARCH_FAIL,
  CATEGORY_SEARCH_RESET,
  ADD_CATEGORY_FAIL,
  ADD_CATEGORY_REQUEST,
  ADD_CATEGORY_SUCCESS,
  DELETE_CATEGORY_FAIL,
  DELETE_CATEGORY_REQUEST,
  DELETE_CATEGORY_SUCCESS,
  CATEGORY_SINGLE_RESET,
} from "./categoryTypes";

export const departmentListReducer = (state = { departments: [] }, action) => {
  switch (action.type) {
    case DEPARTMENT_LIST_REQUEST:
      return { ...state, loading: true, departments: [] };
    case DEPARTMENT_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        departments: action.payload,
      };
    case DEPARTMENT_LIST_FAIL:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export const categoryListReducer = (state = { categories: [], subcategory: {} }, action) => {
  switch (action.type) {
    case CATEGORY_LIST_REQUEST:
      return { ...state, loading: true, categories: [] };
    case CATEGORY_LIST_SUCCESS:
      return { ...state, loading: false, categories: action.payload };
    case CATEGORY_LIST_FAIL:
      return { ...state, loading: false, error: action.payload };

    case CATEGORY_SINGLE_REQUEST:
      return { ...state, singleLoading: true };
    case CATEGORY_SINGLE_SUCCESS:
      return { ...state, singleLoading: false, category: action.payload };
    case CATEGORY_SINGLE_FAIL:
      return { ...state, singleLoading: false, error: action.payload };
    case CATEGORY_SINGLE_RESET:
      return { ...state, singleLoading: false, category: {} };

    case CATEGORY_SEARCH_REQUEST:
      return { ...state, loading: true, searchCategories: {} };
    case CATEGORY_SEARCH_SUCCESS:
      return { ...state, loading: false, searchCategories: action.payload };
    case CATEGORY_SEARCH_FAIL:
      return { ...state, loading: false, error: action.payload };
    case CATEGORY_SEARCH_RESET:
      return { ...state, loading: false, searchCategories: {} };

    case ADD_CATEGORY_REQUEST:
      return { ...state, loading: true, newsubcategory: {} };
    case ADD_CATEGORY_SUCCESS:
      return { ...state, loading: false, newsubcategory: action.payload };
    case ADD_CATEGORY_FAIL:
      return { ...state, loading: false, error: action.payload };

    case DELETE_CATEGORY_REQUEST:
      return { ...state, loading: true };
    case DELETE_CATEGORY_SUCCESS:
      return { ...state, loading: false };
    case DELETE_CATEGORY_FAIL:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};
